<section id="select-action">
  <ul class="action-list">
    <li class="action-list-item">
      <form [formGroup]="actionForm">
        <aside class="initial-action">
          <app-autocomplete #sourceId [selectedOptionControl]="sourceIdControl"
                            [componentId]="'change-insertValue'"
                            [placeholder]="toManyPlaceholderText ? toManyPlaceholderText : 'Type to search...'"></app-autocomplete>
          <app-action-warning-block
            [message]="warningMessage"
            [actionType]="dataRulesService.actionOpName(dataRulesService.actionOperators.INSERT_MULTIPLE)"
          ></app-action-warning-block>
        </aside>
        <aside>
          <div class="message tip">
            <i class="material-icons notranslate">info_outline</i>
            Will INSERT {{certificationRequirement}} entities based on the selected CertificationGroup
          </div>
        </aside>
      </form>
    </li>
  </ul>
</section>
